module.exports = __webpack_public_path__ + "assets/Google.686f8efa.svg";